<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 xl12 md12 sm12 lg12>
        <div class="title text-xs-center form-divider margin-top-40px mb-2">
          <v-btn class="indigo darken-4" large outline flat>لیست شرکت کنندگان</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row class="margin-top-40px">
      <v-flex xs12 lg12 sm12 xl12 md12>
        <v-tabs dark color="indigo" show-arrows>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="i in TabItems" :href="'#' + i.path" :key="i.path">
            <v-icon>{{i.icon}}</v-icon>
            {{i.title}}
          </v-tab>
          <v-tabs-items>
            <v-tab-item id="Users">
              <v-card class="full-width">
                <v-data-table
                  :loading="datatableBool"
                  no-data-text="داده ای یافت نشد"
                  next-icon="$vuetify.icons.prev"
                  prev-icon="$vuetify.icons.next"
                  rows-per-page-text="تعداد سطر در هر صفحه :"
                  :headers="adminTableHeader"
                  :items="UserTableItems"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{props.item.counter}}</td>
                    <td class="text-xs-right">{{props.item.name}}</td>
                    <td class="text-xs-right">{{props.item.class}}</td>
                    <td class="text-xs-right">{{props.item.package}}</td>
                    <td class="text-xs-right">{{props.item.mobile}}</td>
                    <td class="text-xs-right">{{props.item.nfc}}</td>
                  </template>
                  <template v-slot:item.name="props">
                    <v-edit-dialog
                      :return-value.sync="props.item.name"
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                    >
                      {{ props.item.name }}
                      <template v-slot:input>
                        <v-text-field
                          v-model="props.item.name"
                          :rules="[max25chars]"
                          label="Edit"
                          single-line
                          counter
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </template>
                  <template v-slot:item.iron="props">
                    <v-edit-dialog
                      :return-value.sync="props.item.iron"
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                    >
                      <div>{{ props.item.iron }}</div>
                      <template v-slot:input>
                        <div class="mt-4 title">Update Iron</div>
                      </template>
                      <template v-slot:input>
                        <v-text-field
                          v-model="props.item.iron"
                          :rules="[max25chars]"
                          label="Edit"
                          single-line
                          counter
                          autofocus
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import RaceServices from "@/services/RaceServices";
export default {
  data() {
    return {
      dialogNote: {},
      TabItems: [
        { title: " مسابقه دهندگان", path: "Users", icon: "account_circle" }
      ],
      adminTableHeader: [
        {
          text: "نام و نام خانوادگی",
          sortable: true,
          value: "name",
          align: "right"
        },
        {
          text: "کلاس",
          sortable: false,
          value: "class",
          align: "right"
        },
        {
          text: "پکیج",
          sortable: false,
          value: "package",
          align: "right"
        },
        {
          text: "تلفن همراه",
          sortable: false,
          value: "mobile",
          align: "right"
        },
        {
          text: "NFC",
          sortable: true,
          value: "nfc",
          align: "right"
        }
      ],
      UserTableItems: [],
      disabledUserTableItems: [],
      userDeletedDataTableLoading: true,
      datatableBool: true,
      snack: false,
      snackColor: "",
      snackText: "",
      max25chars: v => v.length <= 25 || "Input too long!",
      pagination: {}
    };
  },
  async mounted() {
    setTimeout(() => {
      this.datatableBool = false;
    }, 8000);
    try {
      this.UserTableItems = (await RaceServices.index()).data;
      this.datatableBool = false;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    close() {
      console.log("Dialog closed");
    }
  }
};
</script>

<style scoped>
.margin-top-40px {
  margin-top: 40px;
}
.margin-top-20px {
  margin-top: 20px;
}
</style>
